export default __webpack_public_path__ + "static/media/spotifyAn.2818fa64.jpg";